module.exports = __webpack_public_path__ + "static/media/image_2.ef22dc78.jpg";